module.exports = __webpack_public_path__ + "img/square.6c04bce3.svg";